import React from "react";
import SKIMTableRow from "./SKIMTableRow";
import { EditableRowNames } from "../Data/SKIMData";
import SKIMTotalesRows from "./SKIMTotalesRows";
import { useFormContext, useWatch } from "react-hook-form";
import { MonthHeader } from "../../../Utils/TableComponents";

export default function SKIMMonth(props) {
    const { month, monthIndex } = props;

    const { control } = useFormContext();

    const isFirstTable = month === 'enero';

    let totalKgSecos = 0;
    let totalValorTotal = 0;

    return (
        <table key={monthIndex} >
            <MonthHeader month={month} monthIndex={monthIndex} />
            <tbody>
                {EditableRowNames.map((rowName, rowIndex) => {
                    const RowData = useWatch({
                        control,
                        name: `ComparativoCostoMP.SKIMData.${rowName}`,
                    });
                    if (!RowData) return null;
                    if (!RowData[month]) return null;
                    const kgSecos = RowData[month].KgSecos;
                    const costoKgSec = RowData[month].CostoKgSec;
                    const isNegative = RowData.isNegative;
                    const total = (kgSecos * costoKgSec).toFixed(2);

                    if (isNegative) {
                        totalKgSecos -= parseFloat(kgSecos);
                        totalValorTotal -= parseFloat(total);
                    } else {
                        totalKgSecos += parseFloat(kgSecos);
                        totalValorTotal += parseFloat(total);
                    }

                    return (
                        <SKIMTableRow key={rowIndex}
                            isFirstTable={isFirstTable}
                            rowIndex={rowIndex}
                            rowName={rowName}
                            month={month}
                            monthIndex={monthIndex}
                            total={total}
                        />
                    )
                })}
                <SKIMTotalesRows key={monthIndex}
                    monthIndex={monthIndex}
                    isFirstTable={isFirstTable}
                    month={month}
                    ctoPromedioDelInvenTotalKgSecos={totalKgSecos}
                    ctoPromedioDelInvenTotalValorTotal={totalValorTotal}
                />
            </tbody>
        </table>
    );
}
